import { Form } from 'antd';
import { useMemo } from 'react';
import styled from 'styled-components';
import { getAllFormItemErrors } from '../item/getAllFormItemErrors.tsx';
import { useField } from './useField.tsx';

export interface IFormErrorMessagesProps {
  name: string;
}

export const StyledFormItemErrorMessages = styled(Form.Item)`
  .ant-form-item-control {
    min-height: 0;
  }
  /* per i form-item di errore aggiuntivi */
  .ant-form-item-control-input {
    // Nascondiamo l'input
    visibility: hidden;
    display: none;
  }
  .ant-form-item-explain-error {
    /* padding-top: 2px; */
    padding-bottom: 6px;
    margin-top: -4px;
  }
  .ant-form-item-explain {
    display: block;
  }
`;

export function FormErrorMessages(props: IFormErrorMessagesProps) {
  const { name } = props;
  const { error, touched, isSubmitted } = useField(name);
  const isTouched = touched.some(t => t);
  const errors = useMemo(() => getAllFormItemErrors(error), [error]);
  const hasError = !!errors?.length;

  if (!hasError || (!isTouched && !isSubmitted)) return null; // pf.t4

  return (
    <StyledFormItemErrorMessages
      hasFeedback={isTouched}
      validateStatus={error.length > 0 ? 'error' : 'success'}
      help={errors.map(e => e.error.message).join(', ')}
    />
  );
}
